import { render, staticRenderFns } from "./SurveyGroupDashboardTiles.vue?vue&type=template&id=ecf9737c&scoped=true&"
import script from "./SurveyGroupDashboardTiles.vue?vue&type=script&lang=ts&"
export * from "./SurveyGroupDashboardTiles.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf9737c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
